module.exports = __webpack_public_path__ + "static/media/IOTSU_S1_A01.b7f7eee7.jpg";